import { Stave } from "vexflow";
import { Position } from "./touchListener";

export class NoteMap {
  static noteMap: string[] = ["C", "D", "E", "F", "G", "A", "B"];

  public static getNoteName(stave: Stave, mousePos: Position) {
    //Step 1: get mouse position relative to the stave
    var relativeMouseY = mousePos.y - stave.getBoundingBox().getY();

    //Step 2: get in which space within the staves the user clicked
    //using half the space between lines because we can click between a line (each line can hold 2 notes)
    var noteArea = Math.round(
      relativeMouseY / (stave.options.spacing_between_lines_px / 2)
    );

    //Step 3: use the map to get the note Name
    return this.toNoteName(noteArea, stave);
  }

  public static toNoteName(noteArea: number, stave: Stave) {
    var baseNote = this.getBaseNote(stave);
    var baseNoteValue = NoteMap.noteMap.indexOf(baseNote.note);

    var desiredNoteValue = (baseNoteValue - noteArea) % 7;
    //make it a positive value
    while (desiredNoteValue < 0) desiredNoteValue += 7;

    var desiredNoteOctave = baseNote.octave - Math.floor(noteArea / 7);

    if (desiredNoteValue == 5 || desiredNoteValue == 6) desiredNoteOctave--;

    return NoteMap.noteMap[desiredNoteValue] + "/" + desiredNoteOctave;
  }

  public static getBaseNote = (stave: Stave) => {
    return { note: "G", octave: 6 }; // represents 4 lines above the treble clef
  };
}
